exports.pasos =   [
  /*{
    "index":1,
    "pregunta":"Indique el firmware o sistema operativo que utiliza su dispositivo",
    "respuesta":"",
    "opciones":[],
    "tipo":"Libre",
    "fase":"General",
    "foto":"1.jpg",
    "alias":"versionFirm"
  },*/
  {
    "index":2,
    "pregunta":"Is it updated?",
    "respuesta":"",
    "opciones":["Yes","No","I do not know"],
    "tipo":"Opciones",
    "fase":"General",
    "foto":"2.png",
    "alias":"actualizado",
    "warning":"Warning! Your device is out of date.",
    "consejo":"You should update your device as soon as possible"
  },
  {
    "index":3,
    "pregunta":"Which communication protocols does the device use?",
    "ayudapregunta":"You can look for this information on the Internet, on the manufacturer's website, or in the device's manual",
    "respuesta":[],
    "opciones":["WiFi","Bluetooth LE","6LoWPAN","ZigBee","RFID","NFC","Z-Wave","Otros"],
    "ayuda":
    ["",
    "This stands for Bluetooth Low Energy. If your device uses other versions of Bluetooth, select this option as well.",
    "",
    "It is a protocol used to interconnect Internet of Things devices through a hub or network manager, without the need to connect to the router. If your device meets these characteristics, it is likely to use this protocol.",
    "It is a protocol that is implemented on devices via identifier stickers, similar to QR. If your device has one of these, it probably uses RFID",
    "It is the protocol that is commonly used when making bank payments from mobile devices. It works over very short distances",
    "It is a very similar protocol to ZigBee and is used for the same thing. If your device meets the characteristics described in ZigBee, you should check the specification sheet of your device to find out which of the two protocols it uses",
    ""],
    "tipo":"Check",
    "fase":"General",
    "foto":"3.png",
    "alias":"coms",
    "warning":"Warning! Your device uses the RFID communication protocol, which is very insecure to physical attacks and the tags they use.",
  },
  /*{
    "index":4,
    "pregunta":"¿Qué protocolo de transporte y red utiliza?",
    "respuesta":"",
    "opciones":["TCP/IP","UDP/IP"],
    "tipo":"Opciones",
    "fase":"General",
    "foto":"4.jpg",
    "alias":"transporteyred"
  },*/
  {
    "index":5,
    "pregunta":"Which security protocols does the device use?",
    "respuesta":[],
    "opciones":["TLS","SSL","IPSEC","None","I do not know"],
    "ayuda":["Transport Layer Security. Transport Layer Security. A security protocol used for the transport layer when using TCP","Secure Socket Layer. A security protocol that is used for the transport layer when using TCP","Security protocol associated with the network layer","",""],
    "tipo":"Opciones",
    "fase":"General",
    "foto":"5.jpg",
    "alias":"seguridad",
    "warning":"Warning! Your device does not use security protocols, the information sent and received may be compromised and obtained by third parties."
  },
  {
    "index":6,
    "pregunta":"Is the device connected directly to the network router or indirectly?",
    "respuesta":"",
    "opciones":["Directly","Indirectly"],
    "tipo":"Opciones",
    "fase":"General",
    "foto":"6.jpg",
    "alias":"directamente",
    "warning":"Warning! Take into account that your device is connected directly to your home network. This means that your device is more likely to be targeted by attacks seeking to infiltrate your network."
  },
  {
    "index":7,
    "pregunta":"Indicate the category of your device",
    "ayudapregunta":"If you are not sure about your device's category you can check some examples in the help button of every option",
    "respuesta":"",
    "opciones":["Energy and resource management","Entertainment","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "ayuda":[
    "Heaters, air conditioners, lightbulbs, plugs",
    "Music players, audio speakers, TVs",
    "Feeding systems, intelligent beds, blood pressure monitors",
    "Wireless signal extenders, gateways",
    "Voice command devices, personal assistants",
    "Fridges, vacuum cleaners, coffee machines",
    "Smart locks, cloud cameras",
    "Humidity, CO2, motion, temperature sensors"],
    "tipo":"Opciones",
    "fase":"General",
    "foto":"7.png",
    "alias":"categoria",
    "warning":["Warning! Your device treats with sensitive data. The category "," is formed by a set of devices treating with sensitive data and your privacy may be endangered."]
  },
  {
    "index":8,
    "pregunta":"Is it connected to the cloud?",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"8.jpg",
    "categoria":["Energy and resource management","Entertainment","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"conexnube"
  },
    {
    "index":9,
    "pregunta":"Does the device send data to the cloud?",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"9.png",
    "categoria":["Energy and resource management","Entertainment","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"envnube",
    "warning":"Warning! Take into account that your device sends data to the cloud. Therefore, try to give your device the strictly necessary information for its working.",
    "consejo":"Review the privacy settings of your device in order to check what data is being sent to the cloud"
  },
    {
    "index":10,
    "pregunta":"Select the physical interfaces of your device",
    "respuesta":[],
    "opciones":["USB","Ethernet","Power","Other","It does not have"],
    "tipo":"Check",
    "fase":"Especifica",
    "foto":"10.jpg",
    "categoria":["Entertainment","Networking and utilities","Security and safety"],
    "alias":"entradas",
    "warning":"Warning! The USB protocol is very vulnerable if an attacker manages to insert an infected USB stick into your device.",
    "consejo":"Do not let any stranger insert a USB stick into your device"
  },
  /*{
    "index":11,
    "pregunta":"¿Qué protocolos de comunicación por cable llevan asociadas esas entradas?",
    "respuesta":"",
    "opciones":[],
    "tipo":"Libre",
    "fase":"Especifica",
    "foto":"https://www.metalindustria.com/media/uploads/noticias/wwethernet.jpg",
    "categoria":["Energy and resource management","Entertainment","Networking and utilities","Security and safety"],
    "alias":"entradascom"
  },*/
    {
    "index":11,
    "pregunta":"Does your device have any kind of sensor?",
    "ayudapregunta":"Sensors in a device are responsible for collecting information from the environment. Some examples are: a camera, a microphone or a humidity sensor",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"12.png",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Security and safety","Sensors"],
    "alias":"sensores"
  },
    {
    "index":12,
    "pregunta":"Does it have a microphone that allows you to receive voice commands or a camera?",
    "respuesta":[],
    "opciones":["Microphone","Camera","Other"],
    "tipo":"Check",
    "fase":"Especifica",
    "foto":"13.jpeg",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Security and safety","Sensors"],
    "alias":"microcam",
    "warning":["Warning! Your device has a microphone. An attacker could obtain audios where there could be private information. Moreover, if the device has voice recognition, the attacker could execute attacks to it.","Warning! Your device has a camera. If an attacker gains control of your device, he can obtain images and videos of you and your home without you realising it."],
    "consejo":["Mute the device or turn it off when you are not using it","Cover your camera or turn it off when you are not using it"]
  },
    {
    "index":13,
    "pregunta":"Does your device have actuators?",
    "ayudapregunta":"Actuators perform physical actions based on the commands they receive. For example, a robot hoover has actuators to absorb dust.",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"14.png",
    "categoria":["Energy and resource management","Entertainment","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety"],
    "alias":"actuadores",
    "warning":"Warning! Your device has actuators. If an attacker takes control of your device, he may execute undesired orders to these actuators."
  },
    {
    "index":14,
    "pregunta":"Does your device have any physical button?",
    "respuesta":[],
    "opciones":["ON/OFF","Reset","Volume","Mute microphone","Other"],
    "tipo":"Check",
    "fase":"Especifica",
    "foto":"15.png",
    "categoria":["Energy and resource management","Entertainment","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"boton",
    "warning":"Warning! Your device has a microphone but not a button to mute it.",
    "consejo":"Turn off your device when you are not using it"
  },
  {
    "index":15,
    "pregunta":"Is it possible to remotely access the device via an application?",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"16.png",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"remoto",
    "warning":"Warning! Your device is remotely accessible, therefore an attacker could remotely control your device in the distance.",
    "consejo":"If possible, disable remote access if you are not going to use it"
  },
  {
    "index":16,
    "pregunta":"Does it have two-factor authentication?",
    "ayudapregunta":"The two-factor authentication is a security system in which, in addition to the password, a second confirmation by different methods (SMS, e-mail, etc.) is required for access",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"17.jpg",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"dobleaut",
    "warning":"Warning! Your device does not have two-factor authentication. This is a barrier to stop an attacker from accessing your login credentials.",
    "consejo":"If possible, activate it in your device settings"
  },
  {
    "index":17,
    "pregunta":"Is it based on open source?",
    "ayudapregunta":"Open source is a term used to refer to an application that is publicly developed and its code is accessible to all users",
    "respuesta":"",
    "opciones":["Yes","No"],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"18.png",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Household appliances and kitchen aids","Security and safety","Sensors"],
    "alias":"opensource",
    "warning":"Warning! Your device application is not open source. Open-source applications are supported by the community and are less likely to have security flaws. "
  },
  {
    "index":18,
    "pregunta":"Is it accessible from the web?",
    "respuesta":"",
    "opciones":["Yes, and uses HTTPS","Yes, but does not use HTTPS","No"],
    "ayuda":["Check if the web url begins with \"https\"","",""],
    "tipo":"Opciones",
    "fase":"Especifica",
    "foto":"19.jpg",
    "categoria":["Energy and resource management","Health and wellness","Networking and utilities","Human-machine interface","Security and safety","Sensors"],
    "alias":"web",
    "warning":"Warning! Nowadays, websites that do not use the HTTPS protocol are very vulnerable.",
    "consejo":"Avoid accessing your device application via web"
  }
]